// utils/auth.js
import { jwtDecode } from "jwt-decode";

export const getRoleFromToken = (token) => {
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.role || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const getIsInternalFromToken = (token) => {
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.isInternal || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};